var _rect, _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgPlyUnkitted = function SvgPlyUnkitted(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    "data-name": "Component 27 \\u2013 32",
    viewBox: "0 0 30 30"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "none",
    "data-name": "Rectangle 4603",
    rx: 15
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "m10.278 15.064 4.07 4.459 6.445-8.742",
    "data-name": "Path 11639"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#adadad",
    "data-name": "Rectangle 5047",
    transform: "translate(6 6)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    stroke: "none",
    rx: 9
  }), /*#__PURE__*/React.createElement("rect", {
    width: 17,
    height: 17,
    x: 0.5,
    y: 0.5,
    rx: 8.5
  }))));
};
export default SvgPlyUnkitted;